module.exports = __webpack_public_path__ + "media/guests/assets/images/front_document_image-76811016912bcd6796b366c55665c4e4.png";